module.exports = __webpack_public_path__ + "static/media/background.777c3d10.png";